import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { CardSkeleton } from "@/components/Skeletons";
import { format } from "date-fns";
import { Bell, CheckCheck } from "lucide-react";
import { toast } from "sonner";

export default function Notifications() {
  const [rows, setRows] = useState(null);

  const load = () => api.get("/notifications").then((r) => setRows(r.data));
  useEffect(() => { load(); }, []);

  const markAll = async () => {
    await api.post("/notifications/read-all");
    toast.success("All marked as read");
    load();
  };

  const markOne = async (id) => {
    await api.post(`/notifications/${id}/read`);
    load();
  };

  if (!rows) return <CardSkeleton />;

  return (
    <div className="space-y-5 lg:max-w-3xl">
      <div className="flex items-end justify-between">
        <div>
          <div className="text-xs uppercase tracking-widest text-slate-400 font-semibold">Activity</div>
          <h1 className="heading text-3xl lg:text-4xl font-bold tracking-tight text-slate-900 mt-1">Notifications</h1>
        </div>
        {rows.some((n) => !n.read) && (
          <button
            onClick={markAll}
            className="text-xs px-3 py-2 rounded-full bg-slate-900 text-white font-semibold flex items-center gap-1 active:scale-95"
            data-testid="mark-all-read"
          >
            <CheckCheck className="w-3.5 h-3.5" /> Mark all
          </button>
        )}
      </div>

      {rows.length === 0 && (
        <div className="text-center py-12">
          <Bell className="w-8 h-8 text-slate-300 mx-auto" />
          <p className="text-sm text-slate-500 mt-3">No notifications yet.</p>
        </div>
      )}

      <div className="space-y-2">
        {rows.map((n) => (
          <button
            key={n.id}
            onClick={() => markOne(n.id)}
            className={`w-full text-left p-4 rounded-2xl border ${n.read ? "bg-white border-slate-200" : "bg-emerald-50 border-emerald-200"}`}
            data-testid={`notif-${n.id}`}
          >
            <div className="flex items-start gap-3">
              <div className={`w-2 h-2 rounded-full mt-2 ${n.read ? "bg-slate-300" : "bg-emerald-500"}`} />
              <div className="flex-1">
                <div className="font-semibold text-slate-900 text-sm">{n.title}</div>
                <div className="text-xs text-slate-600 mt-1">{n.message}</div>
                <div className="text-[11px] text-slate-400 mt-2">{format(new Date(n.created_at), "PP • p")}</div>
              </div>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
